const locale = {
  'productList.filter.title': '筛选',
  'productList.filter.reset': '重置',
  'productList.filter.manufacturer': '制造商',
  'productList.filter.manufacturer.placeholder': '车辆选择',
  'productList.filter.years': '年份',
  'productList.filter.years.start.placeholder': '开始年份',
  'productList.filter.years.end.placeholder': '结束年份',
  'productList.filter.models': '车型',
  'productList.filter.models.placeholder': '车型选择',
  'productList.filter.bodycode': '配置',
  'productList.filter.bodycode.placeholder': '配置选择',
  'productList.filter.enginecode': '排量',
  'productList.filter.enginecode.placeholder': '排量选择',
  'productList.filter.catalogs': '配件分类',
  'productList.filter.catalogs.placeholder': '分类选择',

  'productList.message.addToListSuccessfully': '加入清单成功',
  'productList.message.removingListSuccessfully': '移除清单成功',
  'productList.message.addToListFailed': '加入清单失败',
  'productList.message.removingListFailed': '移除清单失败',

  'productList.loginGuidance.oeAndPrice': '登录后可以查看剩余 {total} 条OE及价格',
  'productList.loginGuidance.price': '登录后可以查看价格',

  'productList.old': '旧',
  'productList.old.tips': '此号码为旧号码，汽车制造商当前已不再使用',
  'productList.replaceNum': '替换号',
  'productList.replaceNum.OE': 'OE号',
  'productList.replaceNum.circulationRating': '流通评分',
  'productList.replaceNum.price.OEM': '原厂配套价格',
  'productList.replaceNum.price.aftermarket': '后市场价格',
  'productList.replaceNum.suspensionDate': '停用日期',
  'productList.replaceNum.suspensionDate.tips':
    '汽车制造商停止使用该号码的日期，如日期为空则表明制造商仍在使用此号码',
};

export default locale;
